/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Primary_AccentInputs */

const en_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Accent`)
};

const es_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acento primario`)
};

const fr_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accentuation principale`)
};

const de_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primärer Akzent`)
};

const ja_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセントカラー`)
};

const zh_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强调色`)
};

const ar_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لون التمييز الأساسي`)
};

const id_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksen Utama`)
};

const it_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore di Accento Primario`)
};

const ru_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основной акцентный цвет`)
};

const pt_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de Destaque`)
};

const ko_primary_accent = /** @type {(inputs: Primary_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프라이머리 악센트`)
};

/**
* | output |
* | --- |
* | "Primary Accent" |
*
* @param {Primary_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const primary_accent = /** @type {((inputs?: Primary_AccentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Primary_AccentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_primary_accent(inputs)
	if (locale === "es") return es_primary_accent(inputs)
	if (locale === "fr") return fr_primary_accent(inputs)
	if (locale === "de") return de_primary_accent(inputs)
	if (locale === "ja") return ja_primary_accent(inputs)
	if (locale === "zh") return zh_primary_accent(inputs)
	if (locale === "ar") return ar_primary_accent(inputs)
	if (locale === "id") return id_primary_accent(inputs)
	if (locale === "it") return it_primary_accent(inputs)
	if (locale === "ru") return ru_primary_accent(inputs)
	if (locale === "pt") return pt_primary_accent(inputs)
	return ko_primary_accent(inputs)
});